import request from '../index'

/**
 * 下载福利 list
 * @param {*} params
 * @returns
 */
export function getDownBenefitList(params) {
    return request({
        url: '/box/BoxDownloadBenifit/list',
        method: 'get',
        params
    })
}

/**
 * 用户开团信息
 * @param {*} params 
 * @returns 
 */
export function getUserGroupInfo(params) {
    return request({
        url: '/box/BoxMemberGroupUser/info',
        method: 'get',
        params
    })
}

/**
 * 开团信息
 * @param {*} params 
 * @returns 
 */
export function getGroupInfo(params) {
    return request({
        url: '/box/BoxMemberGroupBuyingDetail/detail',
        method: 'get',
        params
    })
}